import DPAssessmentRubric from "./DPAssessmentRubric";
export default DPAssessmentRubric;
